import { Component, Input, Output, OnInit, EventEmitter, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FieldConfig } from '../../models/config.model';

@Component({
  selector: 'app-web-form-field',
  templateUrl: './web-form-field.component.html',
  styleUrls: ['./web-form-field.component.scss'],
})
export class WebFormFieldComponent implements OnInit {
  @Input() field: FieldConfig;
  @Input() control: FormControl;
  @Output() changeEvent = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.setupValidators();
  }
  get id(): string {
    return this.field?.id || '';
  }

  focus(): void {
    const inputElement = this.getInputElement();
    if (inputElement) {
      inputElement.focus();
    }
  }

  onChange(): void {
    if (this.field?.changeAction) {
      this.changeEvent.emit(this.field.changeAction);
    }
  }

  private setupValidators(): void {
    if (!this.control || !this.field) {
      return;
    }

    const validators = [];

    // Add required validator
    if (this.field.validation?.required) {
      validators.push(Validators.required);
    }

    // Add minLength validator
    if (this.field.validation?.minLength) {
      validators.push(Validators.minLength(this.field.validation.minLength));
    }

    // Add maxLength validator
    if (this.field.validation?.maxLength) {
      validators.push(Validators.maxLength(this.field.validation.maxLength));
    }

    // Add pattern validator
    if (this.field.validation?.pattern) {
      validators.push(Validators.pattern(this.field.validation.pattern));
    }

    // Set the validators to the control
    this.control.setValidators(validators);
    this.control.updateValueAndValidity(); // Update the validity of the control
  }

  public getInputElement(): HTMLInputElement | null {
    return this.elementRef.nativeElement.querySelector('input, select, textarea');
  }
}
